import axiosHttp from "services/axiosHttp";

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "antd";

// Action for uploading a segment price book excel sheet.
// Note: unlike the channel price book upload, this endpoint is not scoped by :id in the URL -
// each row in the sheet carries its own segment name, and the backend resolves the matching
// customer_segment_price_book per row (see segmentPriceBookUpload in pricebook.controller.ts).
export const fetchSegmentPriceBookItemUpload = createAsyncThunk("fetchSegmentPriceBookItemUpload", async ({ file }, { rejectWithValue }) => {
	try {
		const formData = new FormData();
		formData.append("file", file);
		const response = await axiosHttp.post(`price-book/segment/upload`, formData);
		message.success("Prices uploaded successfully!");
		return response.data.data;
	} catch (error) {
		return rejectWithValue(error.response?.data?.message || "Something went wrong");
	}
});

const SegmentPriceBookItemUploadSlice = createSlice({
	name: "SegmentPriceBookItemUploadSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	reducers: {
		resetSegmentPriceBookItemUploadSlice: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(fetchSegmentPriceBookItemUpload.pending, (state) => {
			state.isLoading = true;
			state.error = null;
		});

		builder.addCase(fetchSegmentPriceBookItemUpload.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});

		builder.addCase(fetchSegmentPriceBookItemUpload.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload || "Unknown error occurred";
		});
	},
});

export default SegmentPriceBookItemUploadSlice.reducer;
export const { resetSegmentPriceBookItemUploadSlice } = SegmentPriceBookItemUploadSlice.actions;
